var map = {
	"./icons-chicken.svg": 5341,
	"./icons-gender-female.svg": 6226,
	"./icons-gender-male.svg": 5233,
	"./icons-gender-none.svg": 3338,
	"./icons-meat.svg": 4026,
	"./icons-no-comment.svg": 276,
	"./icons-vegi.svg": 4110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8972;